import { useEffect } from 'react';
import classNames from 'classnames/bind';

import { Link } from 'react-router-dom';
import UserMenu from '../UserMenu';
import NavigationMenu from '../NavigationMenu';
import volo from '../../../../images/logos/volo-color-logo.png';
import search from '../../../../images/Homepage/DiscoverV3/search.svg';
import getDropdownStyles from '../../utilities/getDropdownStyles';
import { Button, LinkToRentals } from '../../../../components';
import { CityFilter } from '../../../../features';
import { dashSpaceSwap } from '../../../../utils/url-search-helpers';
import useDiscoverStore, { DiscoverActions } from '../../../../zustand-stores/DiscoverStore';
import { useUrlParams } from '../../../../hooks';

import styles from '../../../../styles/main.module.scss';

const { clearFilters, updateCityFilter } = DiscoverActions;

const cx = classNames.bind(styles);

const DiscoverHeader = () => {
  const view = useDiscoverStore(store => store.view);
  const subView = useDiscoverStore(store => store.subView);
  const cityName = useDiscoverStore(store => store.filters.cityName);

  const { urlParams, updateUrlParams, replaceUrlParams } = useUrlParams();

  const { cityName: urlCityName } = urlParams;

  useEffect(() => {
    if (cityName && !urlCityName) updateUrlParams({ cityName });
  }, [cityName, urlCityName, updateUrlParams]);

  const dropdownStyles = getDropdownStyles();

  const onSelectCity = ({ label }) => {
    replaceUrlParams({ cityName: label, view, subView });
    clearFilters();
    updateCityFilter(label);
  };

  return (
    <div className={cx('discoverHeader')}>
      <Link className={cx('headerLogo')} to={`/${dashSpaceSwap(cityName, 'toDash')}`}>
        <img width="68px" src={volo} alt="logo" />
      </Link>
      <div className={cx('headerButtons')}>
        <LinkToRentals cityName={cityName}>
          <Button skyblue square className={cx('courtRentalButton')}>
            NEW - COURT RENTALS
          </Button>
        </LinkToRentals>

        <div className={cx('cityButton')}>
          <div className="col">
            <CityFilter
              onSelect={onSelectCity}
              cityName={cityName}
              hideIcon
              hideIndicator
              miscStyles={dropdownStyles}
            />
          </div>
        </div>
        <Button navy className={cx('playNowButton')} square>
          <img src={search} alt="search" />
        </Button>
      </div>
      <div className={cx('headerNavigation')}>
        <NavigationMenu />
        <UserMenu />
      </div>
    </div>
  );
};

export default DiscoverHeader;
